<template>
  <div class="spinner">
        <div 
          :class="`bar${i+1}`" 
          v-for="(item,i) in 12" 
          :key="i" 
          :style="setBackColor">
        </div>
    </div>
</template>
<script>
export default {
  props:{
    main:{
      type:String,
      default:''
    }
  },
  computed:{
    setBackColor(){
      return {
        'backgroundColor':this.main,
        'borderColor':this.main,
      }
    },
  },
}
</script>
<style lang="less" scoped>
@-webkit-keyframes loading {
  from {opacity: 1;width:2px;height:4px;}
  to {opacity: 0.25;width:2px;height:4px;}
}
div.spinner {
  position: absolute;
  top:47%;
  right:20px;
  display: inline-block;
}
div.spinner div {
  width:2px;
  height:6px;
  background: #a4a2a4;
  border:1px solid #fff;
  position: absolute;
  left: 100%;
  top: 100%;
  opacity: 0;
  -webkit-animation: loading 2s linear infinite;
  -webkit-border-radius: 2px;
}
div.spinner div.bar1 {-webkit-transform:rotate(0deg) translate(0, -6px); -webkit-animation-delay: -0s;}
div.spinner div.bar2 {-webkit-transform:rotate(30deg) translate(0, -6px); -webkit-animation-delay: -1.8334s;}
div.spinner div.bar3 {-webkit-transform:rotate(60deg) translate(0, -6px); -webkit-animation-delay: -1.6668s;}
div.spinner div.bar4 {-webkit-transform:rotate(90deg) translate(0, -6px); -webkit-animation-delay: -1.5002s;}
div.spinner div.bar5 {-webkit-transform:rotate(120deg) translate(0, -6px); -webkit-animation-delay: -1.3336s;}
div.spinner div.bar6 {-webkit-transform:rotate(150deg) translate(0, -6px); -webkit-animation-delay: -1.167s;}
div.spinner div.bar7 {-webkit-transform:rotate(180deg) translate(0, -6px); -webkit-animation-delay: -1.0004s;}
div.spinner div.bar8 {-webkit-transform:rotate(210deg) translate(0, -6px); -webkit-animation-delay: -0.8338s;}
div.spinner div.bar9 {-webkit-transform:rotate(240deg) translate(0, -6px); -webkit-animation-delay: -0.6672s;}
div.spinner div.bar10 {-webkit-transform:rotate(270deg) translate(0, -6px); -webkit-animation-delay: -0.5006s;}
div.spinner div.bar11 {-webkit-transform:rotate(300deg) translate(0, -6px); -webkit-animation-delay: -0.334s;}
div.spinner div.bar12 {-webkit-transform:rotate(330deg) translate(0, -6px); -webkit-animation-delay: -0.1674s;}
</style>